// extracted by mini-css-extract-plugin
export default {"spacer":"Spacer_spacer__wYuGD","borderedSpacer":"Spacer_borderedSpacer__h0yIs"};